
/**
 * @figma Pattern 232 · Module List, opt-in appearance of the existing Pro grid.
 * https://www.figma.com/design/HDBjSeAYxCpDOHrBaib9ik/Tools?node-id=3-1366
 * Retains columns, saved dimensions, density, selection and data bindings.
 */
export const moduleListSx = {
  color: "text.primary",
  fontSize: "14px",
  "& .MuiDataGrid-cell": { borderBottom: "1px solid", borderColor: "divider" },
  "& .MuiDataGrid-columnHeaderTitle": { fontSize: "14px", lineHeight: "20px" },
  "& .MuiDataGrid-menuIcon": { visibility: "hidden", width: 0 },
  "& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader:focus-within .MuiDataGrid-menuIcon, & .MuiDataGrid-menuIcon:has([aria-expanded='true'])":
    {
      visibility: "visible",
      width: "auto",
    },
  "@media (hover: none)": {
    "& .MuiDataGrid-menuIcon": { visibility: "visible", width: "auto" },
  },
  "& .MuiDataGrid-menuIcon .MuiSvgIcon-root": { fontSize: 18 },
  "& .MuiDataGrid-footerContainer": { borderBottom: "none !important", mb: 0 },
  "& .MuiTablePagination-root": { fontSize: "13px" },
  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
    fontSize: "13px",
  },
};

/** Pattern 153 · Action Bar geometry. Owned by the shared composite toolbar. */
export const moduleListToolbarSx = {
  gap: { xs: 1, md: "24px" },
  "& .MuiButton-root": { mx: 0 },
  "& .MuiFab-root": {
    width: 36,
    height: 36,
    minWidth: 36,
    minHeight: 36,
    mr: 0,
    "& .MuiSvgIcon-root": { fontSize: 20 },
  },
  "& .MuiButton-startIcon .MuiSvgIcon-root, & .MuiButton-endIcon .MuiSvgIcon-root":
    { fontSize: 20 },
  "& > .MuiButton-root": { pr: "20px" },
  "& > .MuiIconButton-root[aria-haspopup='true']": {
    width: 36,
    height: 36,
    ml: "20px",
    mr: 0,
    "& .MuiSvgIcon-root": { fontSize: 20 },
  },
};

// Pattern 180 (the Quick Filters row and its chips) is QuickFilterBar.tsx's: every list and board
// draws it from there (Aaron 2026-10-13, "Figma Pattern 180").
